module.exports = __webpack_public_path__ + "static/img/home4.a45d5b01.png";